<template>
  <div>
    <v-alert border="right" colored-border elevation="2" type="info">
      <v-row align="center">
        <v-col class="grow">Accesso non ancora attivo</v-col>
        <v-col class="shrink">
          <v-btn @click="login">login</v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <div id="firebaseui-auth-container"></div>
    <div id="googleAuthloader" style="display: none;">Loading...</div>
  </div>
</template>
<script>
import firebase from "firebase/app";
const firebaseui = require("firebaseui");
// https://vue-view.com/making-a-one-click-google-sign-in-for-vue-js-application/
export default {
  name: "App",
  methods: {
    login() {
      const domain =
        process.env.NODE_ENV === "development"
          ? location.href
          : "https://nv1500.web.app/";

      // Initialize the FirebaseUI Widget using Firebase.
      const ui = new firebaseui.auth.AuthUI(firebase.auth());
      const uiConfig = {
        callbacks: {
          /*
          signInSuccessWithAuthResult: function(authResult, redirectUrl) {
            // console.log({ authResult, redirectUrl });
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            return true;
          },
          */
          uiShown: function() {
            // The widget is rendered.
            // Hide the loader.
            document.getElementById("googleAuthloader").style.display = "none";
          }
        },
        // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
        signInFlow: "popup",
        signInSuccessUrl: domain,
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          firebase.auth.GoogleAuthProvider.PROVIDER_ID
        ],
        // Terms of service url.
        tosUrl: "https://nv1500.web.app/",
        // Privacy policy url.
        privacyPolicyUrl: "https://nv1500.web.app/"
      };

      ui.start("#firebaseui-auth-container", uiConfig);
    }
  },
  components: {
    // HelloWorld
  },
  data: () => ({})
};
</script>
